export const authRegex = {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!_%*?&]{8,}$/,
};

export const authErrorMessages = {
    firstname: 'Введите имя',
    lastname: 'Введите фамилию',
    email: 'Введите адрес электронной почты',
    invalidEmail: 'Введите корректный адрес электронной почты',
    password: 'Введите пароль',
    invalidPassword: 'Пароль должен содержать как минимум одну строчную букву, одну заглавную букву и одну цифру, а также быть не менее 8 символов в длину',
    confirmPassword: 'Подтвердите пароль',
    passwordMismatch: 'Пароли не совпадают',
    checkboxState: 'Вы должны прочесть пользовательское соглашение',
    login: 'Введите логин'
};

export const roleType = {
    private_user: 'Частный пользователь',
    superadmin: 'Супер админ',
    admin: 'Администратор',
    teacher: 'Учитель',
    student: 'Ученик'
}
